import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { DropdownEditorComponent } from '@irb-common/components/grid/editors/dropdown-editor.component';
import { DropdownRendererComponent } from '@irb-common/components/grid/renderers/dropdown.cell.component';
import { TruncateTooltipCellComponent } from '@irb-common/components/grid/renderers/truncatetooltip.cell.component';
import { ImportExternalAccountsSecuritiesDialogComponent } from '@irb/irb-clients/import-external-accounts-securities-dialog/import-external-accounts-securities-dialog.component';
import {DropdownFilterRendererComponent} from "@irb-common/components/grid/renderers/dropdown-filter.cell.component";
import {IDropdownItem} from "@irb-common/models/dropdown.model";

@Injectable({
    providedIn: 'root'
})
export class ImportExternalAccountsUnrecognizedGridLayoutService implements GridLayoutService<ImportExternalAccountsSecuritiesDialogComponent> {
    constructor() {}

    getFrameworkComponents() {
        return {
            "DropdownEditorComponent": DropdownEditorComponent,
            "DropdownRendererComponent": DropdownRendererComponent,
            "DropdownFilterRendererComponent":DropdownFilterRendererComponent,
            "TruncateTooltipCellComponent": TruncateTooltipCellComponent
        };
    }

    getColumnDefs(parent: ImportExternalAccountsSecuritiesDialogComponent) {
        return [{
            headerName: 'Select All',
            headerComponent: 'customHeader',
            cellRenderer : 'customHeader',
            cellRendererParams: {parentObject: parent, type: 'rowCheckBox' },
            suppressColumnsToolPanel: true,
            suppressSizeToFit: true,
            toolPanelClass: 'toolpanel-header-checkbox-hide',
            headerComponentParams: {parentObject: parent, type: 'headerCheckBox' },
            suppressMovable: true,
            lockPosition: true,
            lockVisible: true,
            sorting: false,
            filter: true,
            resizable: false,
            minWidth: 25,
            width: 25,
            maxWidth:25,
            cellStyle: {'padding' : '5px 3px 0 2px'},
            headerClass: 'customHeaderClassSelectAll',
            cellClass: 'selectAllCheckBoxRecord'
        },{
            headerName: 'Symbol/CSP',            
            field: 'securitySymbol',
            maxWidth: 100,
            width: 100,
            sort:'asc'
        },
        {
            headerName: 'Description',
            field: 'securityDescription',
            maxWidth: 371,
            cellRenderer: "TruncateTooltipCellComponent",
            cellRendererParams: {
                placeholder: "Description (optional)"
            },
            editable: true
        },
        {
            headerName: 'Type',
            field: 'securityType',
            maxWidth: 100,
            width: 100,
            cellRenderer : 'DropdownRendererComponent',
            cellRendererParams: {
                values: parent.securityTypes,
                defaultValue: {id:'EXTERNAL', name:'External'},
                identifier: "id"
            },
            editable: true,
            cellEditor: 'DropdownEditorComponent',
            cellEditorParams: {
                values: parent.securityTypes,
                defaultValue: {id:'EXTERNAL', name:'External'},
                identifier: "custCatId"
            }
        },
        {
            headerName: 'Custom Category',
            field: 'customCategoryId',
            maxWidth: 160,
            width: 160,
            colId: "custCategoryCol",
            cellRenderer : 'DropdownFilterRendererComponent',
            cellClass: 'dropdownFilterCell',
            cellRendererParams: (params: any) => {
                return {
                    values: parent.securitiesCustomCategories,
                    defaultValue: this.getDefaultCustomCategory(params, parent.securitiesCustomCategories),
                    disabled: false,
                    onChange: (params: any, item: IDropdownItem) => {
                        params.data.customCategoryId = item.value;
                        params.api.redrawRows({rowNodes: [params.node]});
                    }
                }
            }
        },
        {
            headerName: 'External Share Price',
            field: 'externalSharePrice',
            maxWidth: 100,
            width: 120,
            cellRenderer: 'cellRendererFormatter',
            cellRendererParams: { type: 'currency' },
            editable: true,
            valueSetter: (params: any) => {
                params.data.externalSharePrice = (isNaN(params.newValue)) ? 1 : parseFloat(params.newValue);
                return true;
            }
        },];
    }

    getDefaultCustomCategory(params: any, securitiesCustomCategories: any[]) {
        let defaultValue = {name:'Uncategorized', value:0};
        if(params.data?.customCategoryId) {
            let customCategory = securitiesCustomCategories.find((x:any)=> x.value == params.data.customCategoryId);
            if(customCategory) {
                defaultValue = customCategory;
            }
        }
        return defaultValue
    }

}
